import { render, staticRenderFns } from "./ListadoExpedientes.vue?vue&type=template&id=2d6617f2&"
import script from "./ListadoExpedientes.vue?vue&type=script&lang=js&"
export * from "./ListadoExpedientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports